import { defineComponent as r, openBlock as l, createBlock as a, unref as p, mergeProps as c, withCtx as d, createElementVNode as o } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconGrowth",
  __name: "IconGrowth",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (m, e) => (l(), a(p(i), c(n, { "view-box": "0 0 24 24" }), {
      default: d(() => [...e[0] || (e[0] = [
        o("path", { d: "M16.75 10.31V12a.75.75 0 0 0 1.5 0V9A1.25 1.25 0 0 0 17 7.75h-3a.75.75 0 0 0 0 1.5h1.69l-3.19 3.19-1.616-1.617a1.25 1.25 0 0 0-1.768 0L5.97 13.97a.75.75 0 1 0 1.06 1.06L10 12.06l1.616 1.617a1.25 1.25 0 0 0 1.767 0l3.367-3.366" }, null, -1),
        o("path", {
          "fill-rule": "evenodd",
          d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
